import * as React from "react";
const SvgFiRrHoodCloak = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-hood-cloak_svg__a)">
      <path d="M24 12c0-.964-.502-3.481-1.502-5.065C22.177 6.425 22 5.86 22 5.347c0-.354.621-.92.992-1.256.242-.221.456-.422.597-.592a2.12 2.12 0 0 0 .292-2.276A2.11 2.11 0 0 0 21.954.002H14c-1.033 0-1.954.009-2.603.041C5.345.338.356 5.301.042 11.338c-.196 3.764.558 6.877 2.442 10.096a.34.34 0 0 1 0 .355.36.36 0 0 1-.319.186H1a1 1 0 1 0 0 2h1.165c.858 0 1.627-.445 2.055-1.191a2.33 2.33 0 0 0-.009-2.361c-1.699-2.9-2.349-5.586-2.171-8.981.262-5.025 4.415-9.156 9.455-9.403A56 56 0 0 1 14 1.999h7.954c.027 0 .083 0 .116.073.037.079-.005.13-.021.15-.094.114-.241.242-.403.389C20.991 3.207 20 4.109 20 5.346c0 .9.279 1.818.807 2.655C21.536 9.155 22 11.276 22 12c0 3.267-.54 5.323-2.221 8.463a2.39 2.39 0 0 0 .051 2.373 2.33 2.33 0 0 0 2.018 1.14H23a1 1 0 1 0 0-2h-1.152a.34.34 0 0 1-.302-.168.4.4 0 0 1-.003-.401C23.38 17.975 24 15.602 24 12" />
      <path d="M12 6c-3.859 0-7 3.346-7 7.458 0 3.85 3.099 7.694 4.944 9.643.549.58 1.279.899 2.056.899a2.8 2.8 0 0 0 2.055-.898C15.902 21.153 19 17.309 19 13.458 19 9.346 15.859 6 12 6m.603 15.726a.82.82 0 0 1-1.206 0c-1.642-1.732-4.396-5.111-4.396-8.268 0-3.01 2.243-5.458 5-5.458s5 2.448 5 5.458c0 3.157-2.755 6.535-4.397 8.268z" />
    </g>
    <defs>
      <clipPath id="fi-rr-hood-cloak_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHoodCloak;
